module.exports = __webpack_public_path__ + "static/campbells.d5045a8a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/campbells.svg
// module id = 416
// module chunks = 59819425949494